import { useEffect, useState } from 'react';
import { TextField } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { Checkbox } from '@/ui';
import { useWorksheetSettingContext } from './context';
export const QuizWorksheetBasicSetting = () => {
  const {
    t
  } = useTranslation(['common']);
  const {
    worksheetTitleDefault,
    worksheetTeacherNameDefault,
    handleWorksheetTitleChange,
    handleWorksheetTeacherNameChange,
    shouldIncludeAnswerPage,
    handleShouldIncludeAnswerPageToggle
  } = useWorksheetSettingContext();
  const [titleTextValue, setTitleTextValue] = useState<string>(worksheetTitleDefault);
  const [teacherNameTextValue, setTeacherNameTextValue] = useState<string>(worksheetTeacherNameDefault);
  useEffect(() => {
    handleWorksheetTitleChange(titleTextValue);
  }, [titleTextValue, handleWorksheetTitleChange]);
  useEffect(() => {
    handleWorksheetTeacherNameChange(teacherNameTextValue);
  }, [teacherNameTextValue, handleWorksheetTeacherNameChange]);
  return <div className="flex flex-col gap-lg" data-sentry-component="QuizWorksheetBasicSetting" data-sentry-source-file="QuizWorksheetBasicSetting.tsx">
      <section>
        <TextField.Root required data-sentry-element="unknown" data-sentry-source-file="QuizWorksheetBasicSetting.tsx">
          <TextField.Label data-sentry-element="unknown" data-sentry-source-file="QuizWorksheetBasicSetting.tsx">{t('common:common.title')}</TextField.Label>
          <TextField.Input maxLength={30} placeholder={worksheetTitleDefault} value={titleTextValue} onChange={e => setTitleTextValue(e.target.value)} data-sentry-element="unknown" data-sentry-source-file="QuizWorksheetBasicSetting.tsx" />
        </TextField.Root>
      </section>
      <section>
        <TextField.Root required data-sentry-element="unknown" data-sentry-source-file="QuizWorksheetBasicSetting.tsx">
          <TextField.Label data-sentry-element="unknown" data-sentry-source-file="QuizWorksheetBasicSetting.tsx">
            {t('common:quizWorksheet.teacherName')}
          </TextField.Label>
          <TextField.Input maxLength={12} placeholder={worksheetTeacherNameDefault} value={teacherNameTextValue} onChange={e => setTeacherNameTextValue(e.target.value)} data-sentry-element="unknown" data-sentry-source-file="QuizWorksheetBasicSetting.tsx" />
        </TextField.Root>
      </section>
      <section className="flex items-center gap-xs text-body-lg-semibold text-default">
        <Checkbox className="rounded-full" id="includeAnswerPage" checked={shouldIncludeAnswerPage} onClick={() => handleShouldIncludeAnswerPageToggle()} data-sentry-element="Checkbox" data-sentry-source-file="QuizWorksheetBasicSetting.tsx" />
        <label htmlFor="includeAnswerPage">
          {t('common:quizWorksheet.includeAnswerPage')}
        </label>
      </section>
    </div>;
};